<div class="announcements-container row w-100 rounded overflow-hidden shadow bg-white">
  <ng-container *ngIf="announcement.Image">
    <div class="col-lg-6">
      <img class="announcement-image" src="{{ announcement.Image | contentImage : '23' }}" alt="{{ announcement.Image }}" />
    </div>
  </ng-container>
  <div class="col-lg-6 announcements-text font-size-14 text-left">
    <a href="{{ announcement.LinkUrl }}">
      <div class="announcements-title mb-3 font-size-12 fw-bold text-capitalize">{{ announcement.Title }}</div>
      <div class="announcements-info text-grey" [innerHTML]="announcement.Description"></div>
    </a>
  </div>
</div>
